import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axios';

// Ahora acepta un objeto con proscai_id, page y per_page
export const fetchTickets = createAsyncThunk(
  'tickets/fetchTickets',
  async ({ proscai_id, page = 1, per_page = 9999 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`api/v1/collections/documents-v2/`, {
        params: {
          proscai_id,
          page,
          per_page,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener tickets');
    }
  }
);

export const fetchLiquidaciones = createAsyncThunk(
  'tickets/fetchLiquidaciones',
  async ({ proscai_id, page = 1, per_page = 9999 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `api/v1/clientes/${proscai_id}/liquidacion-promociones/`
      );
      const {data} = response;

      if (Array.isArray(data)) {
        return data;
      }
      return [data];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener tickets');
    }
  }
);

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState: {
    tickets: [],
    liquidaciones: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTickets: (state) => {
      state.tickets = null;
    },
    clearLiquidaciones: (state) => {
      state.liquidaciones = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLiquidaciones.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLiquidaciones.fulfilled, (state, action) => {
        state.loading = false;
        state.liquidaciones = action.payload;
      })
      .addCase(fetchLiquidaciones.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.liquidaciones = []; // También limpia en caso de error
      });
  },
});

export const { clearTickets, clearLiquidaciones } = ticketsSlice.actions;
export default ticketsSlice.reducer;
